(() => {
  const sourcePageSize = 24;

  async function loadArticles(section) {
    if (section.dataset.loading === 'true') return;
    const page = Number(section.dataset.currentPage);
    const firstSize = Number(section.dataset.firstPageSize);
    const size = Number(section.dataset.followingPageSize);
    if (page <= 1 || firstSize === size) return;

    const offset = firstSize + (page - 2) * size;
    const firstSourcePage = Math.floor(offset / sourcePageSize) + 1;
    const grid = section.querySelector('.tm-blog__grid');
    const error = section.querySelector('[data-blog-pagination-error]');
    if (!grid) return;
    const totalArticles = Number(grid.dataset.totalArticles);
    const lastSourcePage = Math.floor((Math.min(offset + size, totalArticles) - 1) / sourcePageSize) + 1;
    section.dataset.loading = 'true';
    grid.setAttribute('aria-busy', 'true');
    error.hidden = true;

    try {
      const sources = await Promise.all(Array.from({ length: lastSourcePage - firstSourcePage + 1 }, async (_, index) => {
        const sourcePage = firstSourcePage + index;
        const url = new URL(window.location.href);
        url.hash = '';
        url.searchParams.delete('sections');
        url.searchParams.set('section_id', 'blog-pagination-source');
        url.searchParams.set('page', sourcePage);
        const response = await fetch(url, { credentials: 'same-origin' });
        if (!response.ok) throw new Error('Blog pagination request failed');
        const document = new DOMParser().parseFromString(await response.text(), 'text/html');
        const source = document.querySelector('[data-blog-pagination-source]');
        if (!source || Number(source.dataset.offset) !== (sourcePage - 1) * sourcePageSize) {
          throw new Error('Invalid blog pagination source');
        }
        return source;
      }));

      const total = Number(sources[0].dataset.total);
      const expectedCount = Math.max(0, Math.min(size, total - offset));
      const articles = sources.flatMap((source) => [...source.querySelectorAll('[data-blog-article]')]);
      const visible = articles.slice(offset % sourcePageSize, offset % sourcePageSize + expectedCount);
      if (visible.length !== expectedCount || !expectedCount) throw new Error('Incomplete blog pagination source');
      const cards = visible.map((article) => {
        const card = article.querySelector('.tm-article-card');
        if (!card) throw new Error('Missing blog article card');
        for (const [setting, selector] of [
          ['showAuthor', '.tm-article-card__author'],
          ['showDate', '.tm-article-card__date'],
          ['showExcerpt', '.tm-article-card__excerpt'],
          ['showTags', '.tm-article-card__tag'],
        ]) {
          if (section.dataset[setting] !== 'true') card.querySelector(selector)?.remove();
        }
        return card;
      });

      const itemListScript = [...section.querySelectorAll('script[type="application/ld+json"]')]
        .find((script) => JSON.parse(script.textContent)['@type'] === 'ItemList');
      if (itemListScript) {
        const itemList = JSON.parse(itemListScript.textContent);
        itemList.numberOfItems = total;
        itemList.itemListElement = visible.map((article, index) => ({
          '@type': 'ListItem',
          position: offset + index + 1,
          name: article.dataset.title,
          url: new URL(article.dataset.url, window.location.origin).href,
        }));
        itemListScript.textContent = JSON.stringify(itemList);
      }
      grid.replaceChildren(...cards);
    } catch (failure) {
      error.hidden = false;
      console.error('Unable to load blog pagination', failure);
    } finally {
      grid.removeAttribute('aria-busy');
      section.dataset.loading = 'false';
    }
  }

  function initialize(root) {
    root.querySelectorAll('[data-blog-pagination]').forEach((section) => {
      if (section.dataset.paginationInitialized === 'true') return;
      section.dataset.paginationInitialized = 'true';
      section.querySelector('[data-blog-pagination-retry]')?.addEventListener('click', () => loadArticles(section));
      loadArticles(section);
    });
  }

  initialize(document);
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();
